<template>
  <v-container fluid class="pa-0">
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    
    <template>
   
      <iframe :src="'/pdf-embed?slug=' + pdf + '.pdf&url=' + pdfUrl" style="height: calc(100vh - 88px - 44px); width: 100%; border: none;" class="pa-0 ma-0">
        <p>
          Your browser does not support PDFs.
          <a :href="pdfUrl">Download the PDF</a>
          .
        </p>
      </iframe>
    </template>
    
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
// import maxios from "@/services/mediligo-axios";
export default {
  i18n: i18n,
  name: "m2h-pdf",
  props: ['pdfUrl', 'pdf'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      hasError: false,
    }
  },
  async mounted() {
    // await maxios.post("/api/pdf/register/" + this.pdf);
    await this.logPdfOpened()
  },


  methods: {
    async logPdfOpened() {
      this.$root.$emit('post-pdf-opened')
    },
  },
}
</script>

<style scoped>
</style>
